import React, { createContext, useReducer, useContext } from "react";

import { initialState } from "./state";
import { reducer } from "./reducer";
import { IToursSectionState, IToursSectionStoreAction } from "./types";
import { withStoreValueFactory } from "../../../store";

const ToursSectionContext: React.Context<
	[IToursSectionState, React.Dispatch<IToursSectionStoreAction>]
> = createContext<any>(null)

export const ToursSectionProvider: React.FunctionComponent = ({ children }) => {
	return (
        <ToursSectionContext.Provider value={useReducer(reducer, initialState)}>
            {children}
        </ToursSectionContext.Provider>
	)
}

export const withToursSectionStoreValue = withStoreValueFactory(ToursSectionContext)